"use client";
import { useEffect } from "react";
import { PageTitle } from "@/components/shell";

export default function ErrorPage({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);
  return (
    <div className="container" style={{ textAlign: "center", padding: "120px 20px" }}>
      <PageTitle title="Something went wrong" description="We couldn't load this page. Please try again." />
      <div style={{ marginTop: "30px" }}>
        <button className="button primary" onClick={() => reset()}>Try Again</button>
      </div>
    </div>
  );
}
